(function () {
    'use strict';

    angular.module("imApp").factory("powService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3676,
                    parameters: parms || {}
                });
            },
            listOpStatuses: function (parms) {
                return $ihttp.post({
                    method: 3677,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3678,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
